<template>
    <div class="overall-bg p-0">
        <b-container>
            <!-- <b-row>
                <b-col>
                    <BacktoPage path="/Masters"></BacktoPage>
                    <Headerlayout :headertext="$t('Items.ItemMaster.Master')" :contenttext="$t('Items.ItemMaster.content')">
                    </Headerlayout>
                </b-col>
            </b-row> -->
            <b-row class="py-5">
                <b-col>
                    <Loader :loading="loading" />
                    <div v-if="!loading">
                        <MasterEmpty v-if="List.length === 0" eheader="Outbound Issue" econtent="Outbound Issue"
                            eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
                        <Tableview v-if="List.length !== 0" :value="List" :paginator="true"
                            class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu"
                            :loading="loading1" responsiveLayout="scroll" :columns="headers"
                            :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                            @row-click="RowClick">
                            <!-- <template v-slot:Add>
                                <span class="add">
                                    <AddButton @click="IsAdd" :btnname=" $t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                                </span>
                            </template> -->
                            <template v-slot:action="{ data }">
                                <span>
                                    <!-- <EditIcon class="" @click="IsEdit(data)" />
                                    <DeleteIcon class="" @click="IsDelete(data)" /> -->
                                    <EditIcon @click="IsConfirmEdit(data)" />
                                    <DeleteIcon @click="IsConfirmDel(data)" />
                                </span>
                            </template>
                        </Tableview>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
            :content="$t('confirmation.editcontent')" />
        <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
        <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    </div>
    <ItemsRightSidebar v-model:visible="visibleRight" position="right" @close="visibleRight = false" />
</template>

<script lang="ts">
// import Header from '../../components/Layout/Header.vue';
import { defineComponent, ref, h, onMounted, computed, watch } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";

import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";

import Itemcreation from "../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/ItemCreation.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";
import service from "../../../../../modules/Inventory/Service/ItemMasService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ItemsRightSidebar from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsRightSidebar.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from '../../../../../components/FormComponents/Loader.vue'

export default defineComponent({
    components: {
        BacktoPage,
        Headerlayout,
        Itemcreation,
        axios,

        Tableview,
        EditConfirmation,
        DeleteConfirmationVue,
        DeletedSuccessfully,
        ItemsRightSidebar,
        MasterEmpty,
        Loader
    },
    props: {
        propsParams: {
            type: Object
        }
    },
    setup(props) {
        debugger;

        const router = useRouter();
        const filter = "";
        const showmodalref = ref(false);
        let loading1 = ref(false);
        let loading = ref(false);
        let title = "Item Master";
        const showDialog = ref(false);
        let List = ref([]);
        const selectedItem = ref();
        const data = ref([]);
        const rowFocus = ref(false);
        const editItems = ref();
        const Editmodel = ref(false);
        const { t } = useI18n();
        const Deletemodel = ref(false);
        const visibleRight = ref(false);
        const deletepop = ref(false);



        const headers = [
            {
                header: "Items Code",
                field: "Code",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "HSN",
                field: "HSNName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: "Name",
                field: "ItemName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass width150',

            },
            {
                header: "Mfgr",
                field: "ManufactureName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'width150',

            },
            // {
            //     header: "Average Landing cost",
            //     field: "AverageLandingcost",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            {
                header: "Tax %",
                field: "PurchasePercentage",
            },
            {
                header: "MRP",
                field: "MRP",
            },
            // {
            //     header: "Margin",
            //     field: "margin",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            // {
            //     header: "Quantity",
            //     field: "",
            //     bodyclass: 'boldclass',

            // },

            // {
            //     header: "Quantity Value",
            //     field: "QuantityValue",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            // },
            {
                header: "Supplier #",
                field: "SupplierCount",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'bluecolor',

            },
            // {
            //     header: "Similar Generic",
            //     field: "SimilarGeneric",
            //     filterTemplate: "MultiSelect",
            //     ShowMactchMode: false,
            //     bodyclass: 'bluecolor',

            // },

            // {
            //     header: "Actions",
            //     field: "action",
            //     slot: "action",
            //     frozencolumn: true,
            //     sortable: false,
            // },
        ];

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
            HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ManufactureName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
            ItemCategoryName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemGroupName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemSubGroupName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
            ItemGenericName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: List,
            },
        };

        onMounted(() => {
            debugger;
            document.addEventListener("keydown", onKeyUp);
            IsShow();
        });
        const dataEdit = ref();
        function onKeyUp(event: any) {
            debugger;

            console.log(dataEdit.value);
            if (
                (event.key == "e" ||
                    (Editmodel.value == false && event.key == "Enter")) &&
                rowFocus.value == true
            ) {
                Editmodel.value = true;
            } else if (event.altKey && event.key == "n") {
                IsAdd();
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Deletemodel.value == true &&
                Editmodel.value == false &&
                rowFocus.value == true
            ) {
                IsDelete(dataEdit.value);
            } else if (
                (event.key == "y" || event.key == "Enter") &&
                Editmodel.value == true &&
                rowFocus.value == true
            ) {
                IsEdit(dataEdit.value);
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Editmodel.value == true
            ) {
                Editmodel.value = false;
            } else if (event.key == "d" && rowFocus.value == true) {
                Deletemodel.value = true;
                Editmodel.value = false;
            } else if (
                event.key == "n" &&
                rowFocus.value == true &&
                Deletemodel.value == true
            ) {
                Deletemodel.value = false;
            } else if (event.key == "Escape" && deletepop.value == true) {
                deletepop.value = false;
            } else if (event.key == "Enter" && rowFocus.value == false) {
                Editmodel.value = false;
            }
        }

        function RowClick(event: any) {
            // debugger;
            // Editmodel.value = true;
            // rowFocus.value = true;
            // dataEdit.value = event.data;
            visibleRight.value = true;
            // router.push({
            //     path: "/ItemMasterDetails",
            //     query: { id: event.data.Id },

            // });
        }
        //Add New PopUp
        const IsAdd = () => {
            router.push({
                path: "/ItemMasterCreation",
            });
        };
        function IsConfirmEdit(data) {
            debugger;
            dataEdit.value = data;
            Editmodel.value = true;
        }
        function IsConfirmDel(data) {
            debugger;
            dataEdit.value = data;
            Editmodel.value = false;
            Deletemodel.value = true;
        }
        // Popup-Close
        function closetrigger() {
            deletepop.value = false;
        }
        debugger;
        const routers = useRoute()
        const ParamValues = ref({
            manufaturerid: 0,
        });
        let manufacturerId = routers.query.id;
        console.log(manufacturerId);
        ParamValues.value.manufaturerid = Number(manufacturerId);
        console.log(ParamValues.value.manufaturerid);
        watch(
            () => routers.query.id,
            (newVal: any) => {
                debugger;

                ParamValues.value.manufaturerid = Number(newVal)
                console.log(ParamValues.value.manufaturerid);

                IsShow()
            }
        );
        //Table List
        async function IsShow() {
            debugger;

            try {
                loading.value = true
                const data_response = await service.getdata();
                List.value = data_response["result"]
                    .filter((item) => item.ManufactureId == ParamValues.value.manufaturerid);

                console.log(List.value);
                loading.value = false

            } catch (error) {
                alert(error);
            }
        }

        //Edit Click function
        async function IsEdit(data) {
            debugger;
            router.push({
                path: "/ItemMasterCreation",
                query: { id: data.Id },
            });
        }

        //Row Delete
        async function IsDelete(data) {
            debugger;

            const DelID = data.Id;
            try {
                const data_response = await service.Delete(DelID);
                console.log(data_response);
                deletepop.value = true;
                Deletemodel.value = false;
                rowFocus.value = false;
                IsShow();
            } catch (error) {
                alert(error);
            }
        }

        return {
            title,
            headers,
            filter,
            showmodalref,
            showpopModal: showmodalref,
            loading1,
            loading,
            List,
            IsDelete,
            filters,
            globalFilterFields,
            filteredColumns,
            IsShow,
            IsEdit,
            RowClick,
            dataEdit,
            Editmodel,
            IsAdd,
            onKeyUp,
            IsConfirmEdit,
            IsConfirmDel,
            Deletemodel,
            closetrigger,
            deletepop,
            ParamValues,
            visibleRight,

        };
    },
});
</script>
